skrilla.controller('playerModalCtrl', function ($scope, $q, searchService, cacheService, modalService) {

  $scope.sport = cacheService.getObjectOrElse("contestSport", function(){modalService.dismissAll()});
  $scope.player = cacheService.getObject("player")
  $scope.newAvatarUri = $scope.player.playerAvatarUri
  $scope.newDefaultFranchiseId = $scope.player.playerDefaultFranchiseId


  $scope.overrideAvatarUri = function() {
    searchService.post("players/" + $scope.player.playerId + "/avatarUri", { "uri": $scope.newAvatarUri}, "Successfully updated avatar uri" ).then(function (response) {
      $scope.player.playerAvatarUri = $scope.newAvatarUri;
      modalService.dismissAll();
    });
  }
  $scope.updateDefaultFranchiseId = function() {
    searchService.post("players/" +$scope.player.sport + "/" + $scope.player.playerId + "/defaultFranchiseId", { "franchiseId": $scope.selectedFranchise.id},
      "Successfully updated franchise id" ).then(function (response) {
      $scope.player.playerDefaultFranchiseId = $scope.selectedFranchise.id;
      modalService.dismissAll();
    });
  }

  $scope.query = function(searchText) {
    var deferred = $q.defer();
    if (searchText.length < 3) {
      deferred.resolve([])
    } else {
      searchService.get("franchises/" + $scope.sport +"/quick?q=" + searchText).then(function (response) {
        console.log(response);
        deferred.resolve(response.data.result)
      });
    }
    return deferred.promise
  };
});

